module.exports = __webpack_public_path__ + "img/fluidd_logo.png";